export default {
  init() {
    // JavaScript to be fired on all pages
 
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Code for navbar handling & mobile menu
    const burger = document.querySelector('.logo-burger');
    const root = document.querySelector('html');

    burger.onclick = function() {

       closeRest();

       if (root.classList.contains('menu-open')){
        root.classList.remove('menu-animation');
        setTimeout(function(){
          root.classList.remove('menu-open');
        }, 800);
       } else {
        root.classList.add('menu-open', 'menu-animation');
       }
     }
    // Extend code for reload in the middle of pages
    var scrollPosition = window.scrollY;
    var logoContainer = document.getElementsByClassName('main-header')[0];

    window.addEventListener('scroll', function() {
      scrollPosition = window.scrollY;
      if (scrollPosition >= 30) {
        logoContainer.classList.add('scrolled');
        root.classList.add('scrolled');
      } else {
        logoContainer.classList.remove('scrolled');
        root.classList.remove('scrolled');
      }
    });

    // Code mobile toggle (Changed because we do the mobile menu on desktop too)
    // if (window.innerWidth < 1024) {
    const itemToggle =  document.querySelectorAll('.nav > .menu-item-has-children');

    itemToggle.forEach(function(el){

      el.addEventListener('click', function() {

        if (el.classList.contains('active')) {
        
          el.classList.remove('active');

        } else {
          closeRest();
          el.classList.add('active');
        }

      });
    });

    function closeRest() {
      const hasActive =  document.querySelectorAll('.active');
      for (var i = 0; i < hasActive.length; i++) {
        hasActive[i].classList.remove('active');
      }
    }
    // }

    (function() {
      // cache the document element
      const docElement = document.documentElement;
    
      /**
       * Helper function to change the value of a CSS custom property on the root
       * element.
       *
       * @param {String} prop  name of the CSS custom property
       * @param {*}      value new value for the CSS custom property
       */
      const setRootCssProp = (prop, value) => {
        docElement.style.setProperty(prop, value);
      };
    
      /**
       * Generalization of exponential ease-out functions
       *
       * E.g. easeOutPow(x, 2) is the same as easeOutQuad,
       *      easeOutPow(x, 3) is the same as easeOutCubic, etc.
       *
       * (see https://easings.net)
       *
       * @param {Number} x        floating point value between 0 and 1
       * @param {Number} exponent exponent the power of which to raise x
       * @param {Number} delay    how much to delay the easing; percentage as a floating point value between 0 and 1
       *
       * @returns {Number} the eased number, between 0 and 1
       */
      const easeOutPow = (x, exponent) => {
        return 1 - Math.pow(1 - x, exponent);
      };
      
      /**
       * Like easeOutPow, but with a delay.
       *
       * For all x below the delay, no easing is done; the rest of the way between the end of the delay
       * and the maximum value is stretched so that the easing itself is not simply cut off.
       *
       * @param {Number} x        floating point value between 0 and 1
       * @param {Number} exponent exponent the power of which to raise x
       * @param {Number} delay    how much to delay the easing; percentage as a floating point value between 0 and 1
       *
       * @returns {Number} the eased number, between 0 and 1
       */
      const easeOutPowWithDelay = (x, exponent, delay = 0) => {
        if (x < delay) {
          return 0;
        }
        
        x = (x - delay) / (1 - delay);
        
        return easeOutPow(x, exponent);
      };
    
      const progressBarScroll = () => {
        const winScroll = document.body.scrollTop || docElement.scrollTop;
        const height = docElement.scrollHeight - docElement.clientHeight;
        const percentageScrolled = winScroll / height;
    
        const scrolledFirst = easeOutPowWithDelay(percentageScrolled, 2, 0.6) * 100;
        const scrolledSecond = easeOutPowWithDelay(percentageScrolled, 3, 0.4) * 100;
        const scrolledThird = easeOutPowWithDelay(percentageScrolled, 4, 0.2) * 100;
        const scrolledFourth = easeOutPowWithDelay(percentageScrolled, 5, 0) * 100;
    
        setRootCssProp("--scrolled-first", `${scrolledFirst}%`);
        setRootCssProp("--scrolled-second", `${scrolledSecond}%`);
        setRootCssProp("--scrolled-third", `${scrolledThird}%`);
        setRootCssProp("--scrolled-fourth", `${scrolledFourth}%`);
      };
    
      window.onscroll = () => requestAnimationFrame(progressBarScroll);
    }());

     // Code slidetoggle
     const show = document.querySelector('.more-infos');

     document.querySelectorAll('.slide-toggle').forEach(function(el){
        el.addEventListener('click', function() {
          el.classList.toggle('active');
        });
      });

      // Scroll reveal fun
      function scrollReveal() {
        var revealPoint = 150;
        var revealElement = document.querySelectorAll(".to-reveal");
        for (var i = 0; i < revealElement.length; i++) {
          var windowHeight = window.innerHeight;
          var revealTop = revealElement[i].getBoundingClientRect().top;
          if (revealTop < windowHeight - revealPoint) {
            revealElement[i].classList.add("active");
          } else {
            //revealElement[i].classList.remove("active");
          }
        }
      }
      
      window.addEventListener("scroll", scrollReveal);

      setTimeout(function(){ 
        scrollReveal();
        
      }, 100);
      scrollReveal();
      
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js